/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The ObservationstypeGroupsidObservationTypeGroup model module.
 * @module model/ObservationstypeGroupsidObservationTypeGroup
 * @version v0.3
 */
export default class ObservationstypeGroupsidObservationTypeGroup {
  /**
   * Constructs a new <code>ObservationstypeGroupsidObservationTypeGroup</code>.
   * @alias module:model/ObservationstypeGroupsidObservationTypeGroup
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ObservationstypeGroupsidObservationTypeGroup</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ObservationstypeGroupsidObservationTypeGroup} obj Optional instance to populate.
   * @return {module:model/ObservationstypeGroupsidObservationTypeGroup} The populated <code>ObservationstypeGroupsidObservationTypeGroup</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ObservationstypeGroupsidObservationTypeGroup();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('observation_type_ids'))
        obj.observationTypeIds = ApiClient.convertToType(data['observation_type_ids'], ['String']);
    }
    return obj;
  }
}

/**
 * Observation Type Group Name
 * @member {String} name
 */
ObservationstypeGroupsidObservationTypeGroup.prototype.name = undefined;

/**
 * @member {Array.<String>} observationTypeIds
 */
ObservationstypeGroupsidObservationTypeGroup.prototype.observationTypeIds = undefined;

